module.exports = __webpack_public_path__ + "img/btg.11a0301a.svg";